export const COMPANY = {
  name: 'Summit Enterprises, LLC',
  shortName: 'Summit',
  email: 'eshaqm@gmail.com',
  tagline: "It's at the heart of what we do.",
  headline: 'Empowering Your Business With Innovative Solutions',
};

export const NAV_LINKS = [
  { id: 'approach', label: 'Approach' },
  { id: 'why-us', label: 'Why Us' },
];

export const APPROACH_ITEMS = [
  {
    title: 'Strategic Planning',
    description:
      'We help you define your goals and create a clear, actionable plan to achieve them.',
  },
  {
    title: 'Expert Analysis',
    description:
      'Our data-driven insights enable you to make informed decisions and stay ahead of the competition.',
  },
  {
    title: 'Tailored Solutions',
    description:
      'We understand that every business is unique, so we customize our services to meet your specific needs.',
  },
  {
    title: 'Ongoing Support',
    description:
      'From initial consultation to implementation and beyond, we’re with you every step of the way.',
  },
];

export const WHY_CHOOSE_US = [
  {
    title: 'Experienced Team',
    description:
      'Our consultants bring years of industry experience and a proven track record of success.',
  },
  {
    title: 'Client-Centric Focus',
    description:
      'We prioritize your success and work collaboratively to deliver value at every stage.',
  },
  {
    title: 'Innovative Solutions',
    description:
      'We leverage the latest technologies and methodologies to provide cutting-edge solutions.',
  },
];
